import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import './helpers/setRem'
import { Provider } from 'react-redux'
import { persistor, store } from './redux/store'
import * as Sentry from '@sentry/react'
import { PersistGate } from 'redux-persist/integration/react'
import LoadingSpinner from './components/LoadingSpinner/LoadingSpinner'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { SnackbarProvider } from 'notistack'
import { HelmetProvider } from 'react-helmet-async'
import packageJson from '../package.json'

// // Initialise Sentry
if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        // dsn: "https://1675d9cf203b4b9fc2f376b562062110@o4509359282651136.ingest.us.sentry.io/4509359283961856",
        dsn: 'https://93f1807094e4538224bea56a4e906308@o4509359282651136.ingest.us.sentry.io/4509359289991168',
        release: packageJson.version,
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: true,
        integrations: [Sentry.replayIntegration()],
        ignoreErrors: [
            // Crawler throwing error (safe to ignore):
            // https://trackjs.com/javascript-errors/object-not-found-matching-id-methodname-paramcount/?utm_source=linkedin
            'Object Not Found Matching Id',
        ],
        beforeSend(event, hint) {
            if (hint.originalException === 'Timeout') return null
            return event
        },
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        environment: process.env.REACT_APP_TARGET_ENV,
        initialScope: {
            tags: {
                app_version: packageJson.version,
            },
        },
    })
}

const root = ReactDOM.createRoot(document.getElementById('root') as Element)
const queryClient = new QueryClient()
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate persistor={persistor} loading={<LoadingSpinner />}>
                <HelmetProvider>
                    <QueryClientProvider client={queryClient}>
                        <SnackbarProvider maxSnack={3}>
                            {/* <BrowserRouter> */}
                            <App />
                            {/* </BrowserRouter> */}
                        </SnackbarProvider>
                    </QueryClientProvider>
                </HelmetProvider>
            </PersistGate>
        </Provider>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
